import { useLocation } from "react-router-dom";

import {
  AppBar,
  Toolbar,
  Typography,
  makeStyles,
  Divider,
  Button,
  IconButton,
  Drawer,
  DialogTitle,
  Link,
  MenuItem,
} from "@material-ui/core";

import { project_url, admin_string, secretPass, MULTI_TENANT } from "../constants/Data";
import CryptoJS from "crypto-js";

import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Menu, { MenuProps } from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import React, { useState, useEffect } from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";

import LogoutIcon from "@mui/icons-material/Logout";
import HomeIcon from "@mui/icons-material/Home";
import CancelIcon from "@mui/icons-material/Cancel";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SettingsIcon from "@mui/icons-material/Settings";

import logoImg from "../assets/logo.png";
const headerMenuData = [
  {
    label: "Home",
    href: "/",
  },
  {
    label: "About Us",
    href: `${project_url}/about-us.html`,
  },
  {
    label: "Contact",
    href: `${project_url}/contact.html`,
  },
];

const headerData = [
  {
    label: "Profile",
    href: `${project_url}/profile/`,
  },
  {
    label: "General Settings",
    href: `${project_url}/tenant/settings/`,
  },
];
const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 160,
    color: theme.palette.mode === "light" ? "rgb(55, 65, 81)" : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      fontSize: 16,
      "& .MuiSvgIcon-root": {
        fontSize: 24,
        marginRight: theme.spacing(1.5),
      },
    },
  },
}));
const useStyles = makeStyles(() => ({
  header: {
    backgroundColor: "#FFFEFE",
    color: "black",
    height: "90px",
    justifyContent: "center",
    paddingRight: "10px",
    paddingLeft: "118px",
    marginTop:"5px"
    // "@media (max-width: 963px)": {
    //   //900
    //   paddingLeft: 0,
    //   paddingRight: 0,
    // },
  },
  logo: {
    textAlign: "left",
    height: "58px",
  },
  menuButton: {
    fontFamily: "Roboto, Open Sans, sans-serif",
    fontWeight: 600,
    fontSize: "20px",
    marginRight: "20px",
    height: "50 !important",
  },
  menuItem1: {
    "& .MuiMenuItem-root": {
      fontSize: 16,
      "& .MuiSvgIcon-root": {
        fontSize: 20,
        marginRight: 12,
      },
    },
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
  },
  drawerContainer: {
    padding: "0px 30px",
  },
  buttonStyle: {
    borderRadius: 40,
    paddingLeft: 20,
    paddingRight: 10,
    textTransform: "none",
    backgroundColor: "#F7F4F7",
    "& .MuiButton-startIcon": {
      marginRight: 3,
    },
    "& .MuiButton-endIcon": {
      marginRight: 3,
    },
  },
  signUpButtonStyle: {
    borderRadius: 4,
    width: "180px !important",
    height: "42px",
    textTransform: "none",
    marginTop: -12,
    "& .MuiButton-label": {
      fontFamily: "Roboto, Open Sans, sans-serif",
    },
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  "MuiButton-label": {
    fontFamily: "Roboto, Open Sans, sans-serif",
  },
  mobileSignUpButtonStyle: {
    borderRadius: 4,
    fontFamily: "Roboto, Open Sans, sans-serif",
    width: "170px !important",
    height: "42px",
    textTransform: "none",
    marginTop: 15,
    marginLeft: 40,
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#0D47A1",
    },
  },
  drawerTitle: {
    display: "flex",
    justifyContent: "flex-end",
    padding: 0,
  },
}));

export default function Header() {
  const {
    header,
    logo,
    menuButton,
    toolbar,
    drawerContainer,
    buttonStyle,
    drawerTitle,
    menuItem1,
  } = useStyles();

  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false,
  });

  /// Menu
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const classes = useStyles();
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();
  let fullname = localStorage.getItem("fullname")
    ? localStorage.getItem("fullname")
    : null;
  let email = localStorage.getItem("email") ? localStorage.getItem("email") : null;
  let firstName = localStorage.getItem("firstName")
    ? localStorage.getItem("firstName")
    : "";
  let lastName = localStorage.getItem("lastName") ? localStorage.getItem("lastName") : "";
  let role = localStorage.getItem("role")
            ? CryptoJS.AES.decrypt(localStorage.getItem("role"), secretPass).toString(CryptoJS.enc.Utf8)
            :"";
  ///
  const { mobileView, drawerOpen } = state;

  const { pathname } = useLocation();
  let environment = "";
  if (pathname.match(/\/dev(\/|$)/)) {
    environment = "Dev Site";
  } else if (pathname.match(/\/test(\/|$)/)) {
    environment = "Test Site";
  }


  useEffect(() => {
    setAnchorEl(null);
  }, [window.innerWidth]);

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 1680 //1370 //(RTS-1380)1310 //900
        ? setState(prevState => ({ ...prevState, mobileView: true }))
        : setState(prevState => ({ ...prevState, mobileView: false }));
    };

    setResponsiveness();

    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);

  const handleSignin = () => {
    setState(prevState => ({ ...prevState, drawerOpen: false }));
    navigate(`${project_url}/signin`);
  };

  const handleSignup = () => {
    setState(prevState => ({ ...prevState, drawerOpen: false }));
    navigate(`${project_url}/registration`);
  };

  const displayDesktop = () => {
    return (
      <Toolbar className={toolbar}>
        <a href="/">
          <img src={logoImg} alt="logo" className={logo} style={{ paddingTop: 10 }} />
        </a>
        <div
          style={{
            marginTop: 25,
            width: "100%",
            display: "flex",
            // justifyContent: "space-between",
            // paddingRight: "7rem",
          }}
        >
          {getMenuButtons()}
        </div>
      </Toolbar>
    );
  };

  const displayMobile = () => {
    const handleDrawerOpen = () =>
      setState(prevState => ({ ...prevState, drawerOpen: true }));
    const handleDrawerClose = () =>
      setState(prevState => ({ ...prevState, drawerOpen: false }));

    return (
      <Toolbar className={toolbar}>
        <a href="/">
          <img src={logoImg} alt="logo" className={logo} style={{ paddingTop: 10 }} />
        </a>
        <Box alignItems="center" flexGrow={1}></Box>
        <IconButton
          {...{
            edge: "end",
            color: "inherit",
            "aria-label": "menu",
            "aria-haspopup": "true",
            onClick: handleDrawerOpen,
          }}
        >
          <MenuIcon style={{ marginTop: 0 }} fontSize="28px" />
        </IconButton>
        <Drawer
          {...{
            anchor: "right",
            open: drawerOpen,
            onClose: handleDrawerClose,
          }}
        >
          <DialogTitle className={drawerTitle}>
            <IconButton onClick={handleDrawerClose}>
              <CancelIcon />
            </IconButton>
          </DialogTitle>
          <div className={drawerContainer}>{getDrawerChoices()}</div>
        </Drawer>
      </Toolbar>
    );
  };

  const getDrawerChoices = () => {
    if (email) {
      return (
        <>
          <Typography
            style={{
              fontWeight: 600,
              fontSize: 18,
              color: "#000",
              padding: "12px 16px",
            }}
          >
            {firstName + " " + lastName}
          </Typography>
          <Divider sx={{ my: 0.5 }} />
          <Link
            {...{
              component: RouterLink,
              to: role === "Admin" ? (`${project_url}${admin_string}/dashboard/`) : (role === "Tenant" ? (`${project_url}/tenant/dashboard/`) : ( role === "Applicant" ?  (`${project_url}/applicant/dashboard/`) : "")) ,
              color: "inherit",
              style: { textDecoration: "none" },
              key: "dashboard",
              onClick: { drawerOpen: false },
            }}
          >
            <MenuItem className={menuItem1} disableRipple>
              <HomeIcon style={{ marginRight: 10, marginBottom: 5 }} />
              Dashboard
            </MenuItem>
          </Link>
          <Divider sx={{ my: 0.5 }} />

          <Link
            {...{
              component: RouterLink,
              to: role === "Admin" ? "" : (role === "Tenant" ? (`${project_url}/profile/`) : ( role === "Applicant" ?  (`${project_url}/applicant/profile/`) : "")),
              color: "inherit",
              style: { textDecoration: "none" },
              key: "profile",
              onClick: { drawerOpen: false },
            }}
          >
            <MenuItem className={menuItem1} disableRipple>
              <PersonOutlineIcon style={{ marginRight: 10, marginBottom: 5 }} />
              Profile
            </MenuItem>
          </Link>

          {role === "Tenant" ? 
          <>
          <Link
            {...{
              component: RouterLink,
              to: `${project_url}/tenant/settings/`,
              color: "inherit",
              style: { textDecoration: "none" },
              key: "settings",
              onClick: { drawerOpen: false },
            }}
          > 

            <MenuItem className={menuItem1} disableRipple>
              <SettingsIcon style={{ marginRight: 10, marginBottom: 5 }} />
              General Settings
            </MenuItem>
          </Link>
          </> : ""}

          <Link
            {...{
              component: RouterLink,
              to: role === "Admin" ? (`${project_url}${admin_string}/signout`) : (`${project_url}/signout/`),
              color: "inherit",
              style: { textDecoration: "none" },
              key: "signout",
              onClick: { drawerOpen: false },
            }}
          >
            <Divider sx={{ my: 0.5 }} />
            <MenuItem disableRipple>
              <LogoutIcon style={{ marginRight: 12, marginLeft: 3 }} color="error" />
              Sign Out
            </MenuItem>
          </Link>

          <Divider sx={{ my: 0.5 }} />

          <Divider sx={{ my: 0.5 }} />
          {headerMenuData.map(({ label, href }) => (
            <Link
              {...{
                component: RouterLink,
                to: href,
                color: "inherit",
                style: { textDecoration: "none" },
                key: label,
                onClick: { drawerOpen: false },
              }}
            >
              <MenuItem>{label}</MenuItem>
            </Link>
          ))}
        </>
      );
    } else {
      return (
        <>
          {headerMenuData.map(({ label, href }) => (
            <Link
              {...{
                component: RouterLink,
                to: href,
                color: "inherit",
                style: { textDecoration: "none" },
                key: label,
                onClick: { drawerOpen: false },
              }}
            >
              <MenuItem>{label}</MenuItem>
            </Link>
          ))}
          <Divider sx={{ my: 0.5 }} />

          <Button
            style={{
              top: 8,
              left: 11,
              color: "#9C27B0",
              textTransform: "none",
              fontFamily: "Roboto, Open Sans, sans-serif",
              fontSize: 15,
              fontWeight: 500,
              display: "inline",
            }}
            disableRipple={true}
            id="signinBtn"
            variant="text"
            onClick={handleSignin}
          >
            Sign in
          </Button>
          
          {MULTI_TENANT && (<Button
            className={classes.mobileSignUpButtonStyle}            
            color="primary"
            variant="contained"
            onClick={handleSignup}
          >
            <Typography
              style={{
                color: "white",
                fontFamily: "Roboto, Open Sans, sans-serif",
                fontSize: 15,
                fontWeight: 500,
                lineHeight: 26,
                letterSpacing: "0.46",
              }}
            >
              Tenant Registration
            </Typography>
          </Button>)}
        </>
      );
    }
  };

  const getMenuButtons = () => {
    let data = headerData;
    return (
      <>
        <Box style={{ width: 1050 }}>
          {headerMenuData.map(({ label, href }) => (
            <Button
              {...{
                key: label,
                color: "inherit",
                to: href,
                component: RouterLink,
                style: { textTransform: "none", marginBottom: 30 },
                className: menuButton,
              }}
            >
              {label}
            </Button>
          ))}
        </Box>
        <Box
          style={{
            display: "inline-flex",
            flexDirection: "row",
          }}
        >
          {email && (
            <Box pt={0.5}>
              <Button
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                variant="contained"
                disableElevation
                onClick={handleClick}
                {...{
                  key: "fullName",
                  style: { textTransform: "none" },
                  className: buttonStyle,
                  startIcon: <PersonOutlineIcon />,
                  endIcon: open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />,
                }}
              >
                {firstName + " " + lastName}
              </Button>
              <StyledMenu
                id="demo-customized-menu"
                MenuListProps={{
                  "aria-labelledby": "demo-customized-button",
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
              >
                <Link
                  {...{
                    component: RouterLink,
                    to: role === "Admin" ? (`${project_url}${admin_string}/dashboard/`) : (role === "Tenant" ? (`${project_url}/tenant/dashboard/`) : ( role === "Applicant" ?  (`${project_url}/applicant/dashboard/`) : "")) ,
                    color: "inherit",
                    style: { textDecoration: "none" },
                    key: "dashboard",
                  }}
                >
                  <MenuItem onClick={handleClose} disableRipple>
                    <HomeIcon />
                    Dashboard
                  </MenuItem>
                </Link>
                <Divider sx={{ my: 0.5 }} />

                {/* {data.map(({ label, href }) => (
                  <Link
                    {...{
                      component: RouterLink,
                      to: href,
                      color: "inherit",
                      style: {
                        textDecoration: "none",
                        fontSize: "20px !important",
                      },
                      key: label,
                      onClick: { drawerOpen: false },
                    }}
                  >
                    <MenuItem {...{ style: { fontSize: "20px !important" } }}>
                      {label}
                    </MenuItem>
                  </Link>
                ))} */}
                <Link
                  {...{
                    component: RouterLink,
                    to: role === "Admin" ? "" : (role === "Tenant" ? (`${project_url}/profile/`) : ( role === "Applicant" ?  (`${project_url}/applicant/profile/`) : "")),
                    color: "inherit",
                    style: { textDecoration: "none" },
                    key: "profile",
                  }}
                >
                  <MenuItem onClick={handleClose} disableRipple>
                    <PersonOutlineIcon />
                    Profile
                  </MenuItem>
                </Link>

                <Link
                  {...{
                    component: RouterLink,
                    to: role === "Admin" ? "" : (role === "Tenant" ? (`${project_url}/tenant/settings/`) : ( role === "Applicant" ?  (`${project_url}/applicant/settings/`) : "")),
                    color: "inherit",
                    style: { textDecoration: "none" },
                    key: "settings",
                  }}
                >
                  <MenuItem onClick={handleClose} disableRipple>
                    <SettingsIcon />
                    General Settings
                  </MenuItem>
                </Link>

                <Divider sx={{ my: 0.5 }} />
                <Link
                  {...{
                    component: RouterLink,
                    to: role === "Admin" ? (`${project_url}${admin_string}/signout/`) : `${project_url}/signout/`,
                    color: "inherit",
                    style: { textDecoration: "none" },
                    key: "signout",
                  }}
                >
                  <MenuItem onClick={handleClose} disableRipple>
                    <LogoutIcon color="error" />
                    Sign Out
                  </MenuItem>
                </Link>
              </StyledMenu>
            </Box>
          )}
          {!email && (
            <Box pt={2} style={{ display: "flex" }}>
              <Box ml={0.5}>
                <Link component={RouterLink} to={`${project_url}/signin`} variant="h2" color="primary">
                  Sign in
                </Link>
              </Box>
              {MULTI_TENANT && (<Box ml={3} display="flex" justifyContent="center">
                <Button
                  className={classes.signUpButtonStyle}
                  color="primary"
                  variant="contained"
                  onClick={() => navigate(`${project_url}/registration/`)}
                >
                  Tenant Registration
                </Button>
              </Box>)}
            </Box>
          )}
        </Box>
      </>
    );
  };

  return (
    <header>
      <AppBar className={header}>
        {mobileView ? displayMobile() : displayDesktop()}
        {environment && (
          <Box
            style={{
              textAlign: "center",
            }}
          >
            <span
              style={{
                display: "inline-block",
                backgroundColor: "red",
                color: "white",
                padding: "2px 10px",
                borderRadius: "6px",
                fontWeight: 700,
                fontSize: "20px",
              }}
            >
              {environment}
            </span>
          </Box>
        )}
      </AppBar>
    </header>
  );
}
